module.exports = __webpack_public_path__ + "img/depmap_svg_V18.caa289c7.svg";